import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  OtherBenefitsFlg,
  FormClassRetire,
  RetireFlowReason,
  RetirementInvoiceOrder,
  RetireReason,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import "./_style.scss";
import { fakeTableList, schema, stepper } from "./parts";
import { IAPI_STA008_Request } from "../../type/apiType";
import { IJob_32Props } from "../../type/contextType/businessContext/IJob_32";
import { httpAPI_STA008 } from "./api/request";
import { API_STA008_BuildReqParams } from "../../utils/buildRequestParams";
import _ from "lodash";

/**
 * SCRC060124 退職情報　登録（退職手当金支払いの順番の登録）
 * 職員の退職時の他退職手当金の情報を登録する。
 * @return SCRC060124 退職情報　登録（本俸月額の登録）
 */
const SCRC060124 = () => {
  const navigate = useNavigate();
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_32;
  const [isOpenSaveDialog, setIsOpenSaveDialog] = useState<boolean>(false);
  const isUserTypeKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const [joinFlg, setJoinFlg] = useState("");
  const [order, setOrder] = useState("");

  useEffect(() => {
    let resArr = stateFakeTableList.current;

    // 契約者（法人）名
    let contractor = resArr.find((item) => item.keyword === "contractorName")!;
    contractor.showLine = isUserTypeKiko;
    contractor.contractorNumber = `${businessState.common?.contractorNo}:${businessState.common?.contractorName}`;

    // 職員番号
    let staffNo = resArr.find((item) => item.keyword === "staffNo")!;
    staffNo.text = context?.staffNo;

    // 退職者名
    let retireeName = resArr.find((item) => item.keyword === "retireeName")!;
    retireeName.text = context?.staffNameKanji;

    // 福祉医療機構以外からの退職金受け取りの有無
    let prefectureRetirementJoinFlg = resArr.find(
      (item) => item.keyword === "prefectureRetirementJoinFlg"
    )!;
    prefectureRetirementJoinFlg.setDefaultValue =
      context?.prefectureRetirementJoinFlg;
    context?.prefectureRetirementJoinFlg &&
      handleChangeJoinFlg(context?.prefectureRetirementJoinFlg);

    // 退職手当金請求の順番
    let retirementInvoiceOrder = resArr.find(
      (item) => item.keyword === "retirementInvoiceOrder"
    )!;
    retirementInvoiceOrder.setDefaultValue = context?.retirementRequestOrder;

    setStateInfoList([...resArr]);

    setJoinFlg(context?.prefectureRetirementJoinFlg ?? "");
    setOrder(context?.retirementRequestOrder ?? "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let resArr = stateFakeTableList.current;

    // 福祉医療機構以外からの退職金受け取りの有無
    let prefectureRetirementJoinFlg = resArr.find(
      (item) => item.keyword === "prefectureRetirementJoinFlg"
    )!;
    prefectureRetirementJoinFlg.onGetValue = handleChangeJoinFlg;

    // 退職手当金請求の順番
    let retirementInvoiceOrder = resArr.find(
      (item) => item.keyword === "retirementInvoiceOrder"
    )!;
    retirementInvoiceOrder.onGetValue = handleChangeOrder;

    setStateInfoList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joinFlg, order]);

  const handleChangeJoinFlg = (event: any) => {
    let resArr = stateFakeTableList.current;
    let retirementInvoiceOrder = resArr.find(
      (item) => item.keyword === "retirementInvoiceOrder"
    )!;
    let newList = retirementInvoiceOrder.radioPropsList;

    if (event === OtherBenefitsFlg["他の退職金の受け取り「無」"]) {
      retirementInvoiceOrder.setDefaultValue =
        RetirementInvoiceOrder["福祉医療機構を先に請求"];
      retirementInvoiceOrder.isGuideMessage = false;
      newList[1].disabled = true;
      setOrder(RetirementInvoiceOrder["福祉医療機構を先に請求"]);
    } else {
      newList[1].disabled = false;
      if (
        context?.retirementRequestOrder ===
          RetirementInvoiceOrder["福祉医療機構を後に請求"] &&
        order === RetirementInvoiceOrder["福祉医療機構を先に請求"]
      ) {
        retirementInvoiceOrder.guideMessage =
          TkPropertyMessageGet("TKMSG_SCR0006W");
        retirementInvoiceOrder.isGuideMessage = true;
      }
    }
    retirementInvoiceOrder.radioPropsList = newList;
    setStateInfoList([...resArr]);

    setJoinFlg(event);
  };

  const handleChangeOrder = (event: any) => {
    let resArr = stateFakeTableList.current;
    let retirementInvoiceOrder = resArr.find(
      (item) => item.keyword === "retirementInvoiceOrder"
    )!;

    if (
      context?.retirementRequestOrder ===
        RetirementInvoiceOrder["福祉医療機構を先に請求"] &&
      event === RetirementInvoiceOrder["福祉医療機構を後に請求"]
    ) {
      retirementInvoiceOrder.guideMessage =
        TkPropertyMessageGet("TKMSG_SCR0005W");
      retirementInvoiceOrder.isGuideMessage = true;
    } else if (
      joinFlg !== OtherBenefitsFlg["他の退職金の受け取り「無」"] &&
      context?.retirementRequestOrder ===
        RetirementInvoiceOrder["福祉医療機構を後に請求"] &&
      event === RetirementInvoiceOrder["福祉医療機構を先に請求"]
    ) {
      retirementInvoiceOrder.guideMessage =
        TkPropertyMessageGet("TKMSG_SCR0006W");
      retirementInvoiceOrder.isGuideMessage = true;
    } else {
      retirementInvoiceOrder.isGuideMessage = false;
    }
    setStateInfoList([...resArr]);

    retirementInvoiceOrder.setDefaultValue = event;
    setOrder(event);
  };

  const makeHttpObj = (data: any) => {
    let businessType = "";

    if (context?.nRetireReasonCd === RetireReason["普通退職"]) {
      businessType = "JOB-32";
      context?.retireProcedureReason ===
        RetireFlowReason["法人（業務上の）都合"] &&
        (businessType =
          context?.continueTransferApplicable1Flg === "1" &&
          context?.continueTransferApplicable2Flg === "1"
            ? "JOB-33"
            : "JOB-32");
    } else {
      businessType =
        context?.retireProcedureReason ===
        RetireFlowReason["法人（業務上の）都合"]
          ? "JOB-32"
          : "JOB-31";
    }
    const reqObj: IAPI_STA008_Request = {
      ...data,
      businessType,
      contractorNo: isUserTypeKiko
        ? businessState.common?.contractorNo
        : state.authInfo?.contractorNo,
      tempSaveStep: 5,
      screenId: "SCRC060124",
    };

    return API_STA008_BuildReqParams(reqObj);
  };

  const handleSubmit = async (data: any, index: any) => {
    const dataObj = {
      ...context,
      prefectureRetirementJoinFlg: data.prefectureRetirementJoinFlg,
      retirementRequestOrder: data.retirementInvoiceOrder,
    };

    if (
      data.retirementInvoiceOrder ===
      RetirementInvoiceOrder["福祉医療機構を先に請求"]
    ) {
      Object.keys(dataObj).forEach((item) => {
        if (
          item.startsWith("page1") ||
          item.startsWith("page2") ||
          item.startsWith("page3")
        ) {
          delete dataObj[item as keyof IJob_32Props];
        }
      });
      delete dataObj.withholdingTaxSlipTotal;
      dataObj.formList = dataObj.formList?.filter(
        (item) =>
          !(
            item.formClass ===
              FormClassRetire["退職所得の源泉徴収票_退職届1枚目"] ||
            item.formClass ===
              FormClassRetire["退職所得の源泉徴収票_退職届2枚目"] ||
            item.formClass ===
              FormClassRetire["退職所得の源泉徴収票_退職届3枚目"]
          )
      );
    }

    if (index === 0) {
      // 一時保存
      try {
        const res = await httpAPI_STA008({
          ...makeHttpObj({ ...dataObj }),
        });

        if (res.resultCd === "I0000") {
          setBusinessState({
            ...businessState,
            job_32: {
              ...dataObj,
              tempSaveStep: 5,
              applyId: res.applyId,
              updateDateTime: res.updateDateTime,
            },
          });
          setState({
            ...state,
            errorMsgId: "",
          });
          setIsOpenSaveDialog(true);
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    } else {
      // 次へ
      setBusinessState({
        ...businessState,
        job_32: {
          ...dataObj,
        },
      });
      setState({
        ...state,
        errorMsgId: "",
      });
      if (
        data.retirementInvoiceOrder ===
        RetirementInvoiceOrder["福祉医療機構を先に請求"]
      ) {
        navigate("/SCRC060026");
      } else {
        navigate("/SCRC060125");
      }
    }
  };

  const UpdatedMessage = () => {
    const message = labelids.labelid.LBLC060124_01;

    return (
      <Box className="tkInfoText">
        {message.split("\\n").map((item, index) => (
          <Box key={index} className={index === 3 ? "redLine" : ""}>
            {index === 4 ? (
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫都道府県の共済制度一覧.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                {item}
              </a>
            ) : (
              item
            )}
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Box data-testid="SCRC060124test" className="SCRC060124">
      <TkStepper
        steps={stepper}
        activeStep={4}
        savaStep={context?.tempSaveStep}
      />
      <UpdatedMessage />

      <TkFakeTable
        list={stateInfoList}
        ruleSchema={schema}
        onCheckAndSubmit={handleSubmit}
        buttonGroup={<TkBackButton />}
        submitButtonGroup={[
          { submitButtonText: "一時保存" },
          { submitButtonText: "次へ" },
        ]}
      />

      <TkMessageDialog
        open={isOpenSaveDialog}
        onOky={() => setIsOpenSaveDialog(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC060124;
